import React from 'react'

export default function Ranger(props) {

    const handleInputChange = (evt) => {
        const value = evt.target.value;
        props.onChange(value);
    }
    
    return (
        <input
            id={props.title}
            type='range'
            min={props.min}
            max={props.max}
            step={props.step}
            value={props.value}
            onChange={handleInputChange}
        />
    );
}
